import { render, staticRenderFns } from "./ReposMedicalPrinter.vue?vue&type=template&id=6fb7cf34&"
import script from "./ReposMedicalPrinter.vue?vue&type=script&lang=js&"
export * from "./ReposMedicalPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports